import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { api_menu_list } from '../../../components/states/selector'
import { BrowserRouter, Route, Switch, Link, NavLink, useParams, useHistory, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import { Button, Grid, Box, Container, Typography, Pagination } from '@mui/material'
import Item from '../../blocks/item'
import { CONFIG } from '../../states/settings'



const ItemDetail = ()=>{
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)
  let [ selected_menu, setSelectedMenu ] = useState(null)

  let { id, entry_id } = useParams()
  let { path, url } = useRouteMatch()
  let uh = useHistory()
  let ul = useLocation()
  let from_url = (ul.state && ul.state.from_url) ? ul.state.from_url : '/'


  useEffect(()=>{
    setMenuList(menu_list)

    let item = menu_list.find(v => v.group_name == id)
    setSelectedMenu(item)
  }, [])

  return (
    <Box className='wrapper' sx={{
      '@media (max-width: 900px)':{
        padding: 2
      },
      padding: 3
    }}>
      {
        selected_menu
        ? (
          <>
            <Typography component="h3" variant="h4" sx={{ fontWeight:700 }} className='menu_name_underlayer'>
              <Link to={`${CONFIG.PAGE_ROOT_PATH}/${selected_menu.group_name}/`} className='link_sub'>
                { selected_menu.group_name }
              </Link>
            </Typography>

            <Item
              json_file={selected_menu.json_file}
              from_url={from_url}
            />
          </>
        )
        : (<><h2 className='no_data'>NO DATA</h2></>)
      }
    </Box>
  )
}

export default ItemDetail;

